import { useEffect, useState, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function AddToCartButton({
  loading,
  handleAddToCart,
  quantity,
  toggleWishlist,
  selectedSize,
}) {
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [isSticky, setIsSticky] = useState(true);
  const [height, setHeight] = useState(0);
  const wrapperRef = useRef(null);

  // wishlist sync
  useEffect(() => {
    setIsWishlisted(selectedSize?.is_wishlisted === 1);
  }, [selectedSize]);

  // AUTO HEIGHT (perfect spacing, no jump)
  useEffect(() => {
    if (!wrapperRef.current) return;
    const observer = new ResizeObserver((entries) => {
      const newHeight = entries[0].contentRect.height;
      setHeight(newHeight); 
    });

    observer.observe(wrapperRef.current);

    return () => observer.disconnect();
  }, []);

  // SMOOTH SCROLL (no vibration)
  useEffect(() => {
    const productInfo = document.querySelector(".product-info");
    if (!productInfo) return;

    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      window.requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const viewportBottom = scrollY + window.innerHeight;
        const rect = productInfo.getBoundingClientRect();
        const productBottom = rect.bottom + window.scrollY;
        const buffer = 20;
        const shouldStick = viewportBottom < productBottom - buffer;
        setIsSticky((prev) =>
          prev !== shouldStick ? shouldStick : prev
        );

        ticking = false;
      });

      ticking = true;
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleWishlistClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const next = !isWishlisted;
    setIsWishlisted(next);
    toggleWishlist(e, selectedSize, next);
  };

  return (
    <>
      <div style={{ height: isSticky ? height : 0 }} />
      <div
        ref={wrapperRef}
        className={`add-cart-wrapper ${isSticky ? "sticky" : ""}`}
      >
        <div className="add-cart-section">
          {loading ? (
            <>
              <Skeleton height={45} width={260} />
              <Skeleton width={36} height={36} />
            </>
          ) : (
            <>
              <button
                type="button"
                className="add-to-cart-btn_qucick"
                onClick={handleAddToCart}
                disabled={quantity === 0}
              >
                {quantity === 0 ? "Out of stock" : "ADD TO CART"}
              </button>

              <button
                  className="wst_box pointer-crusser mt-0"
                  onClick={(e) => toggleWishlist(e, selectedSize)}
                  >
                  <i
                    className={`bi ${
                      selectedSize?.is_wishlisted
                        ? "bi-heart-fill text-danger"
                        : "bi-heart"
                    }`}
                  />
                </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
export default AddToCartButton;